
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionMSBWidget/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionMSBWidget/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionPageWidget/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionPageWidget/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller2 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionWidget/viewer.controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionWidget/model.ts';
            var controllerExport2 = _controllerExport2;
            

            
import wrapController3 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller3 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionsGalleryWidget/viewer.controller.ts';
            import * as _controllerExport3 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionsGalleryWidget/model.ts';
            var controllerExport3 = _controllerExport3;
            

            
import wrapController4 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller4 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionsListWidget/viewer.controller.ts';
            import * as _controllerExport4 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionsListWidget/model.ts';
            var controllerExport4 = _controllerExport4;
            

            
import wrapController5 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller5 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/featuredCollectionWidget/viewer.controller.ts';
            import * as _controllerExport5 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/featuredCollectionWidget/model.ts';
            var controllerExport5 = _controllerExport5;
            

            
import wrapController6 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller6 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/navigationButtonWidget/viewer.controller.ts';
            import * as _controllerExport6 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/navigationButtonWidget/model.ts';
            var controllerExport6 = _controllerExport6;
            

            
import wrapController7 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller7 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/navigationWidget/viewer.controller.ts';
            import * as _controllerExport7 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/navigationWidget/model.ts';
            var controllerExport7 = _controllerExport7;
            

            
import wrapController8 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller8 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/portfolioPageWidget/viewer.controller.ts';
            import * as _controllerExport8 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/portfolioPageWidget/model.ts';
            var controllerExport8 = _controllerExport8;
            

            
import wrapController9 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller9 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectDetailsWidget/viewer.controller.ts';
            import * as _controllerExport9 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectDetailsWidget/model.ts';
            var controllerExport9 = _controllerExport9;
            

            
import wrapController10 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller10 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectHeaderWidget/viewer.controller.ts';
            import * as _controllerExport10 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectHeaderWidget/model.ts';
            var controllerExport10 = _controllerExport10;
            

            
import wrapController11 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller11 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectPageWidget/viewer.controller.ts';
            import * as _controllerExport11 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectPageWidget/model.ts';
            var controllerExport11 = _controllerExport11;
            

            
import wrapController12 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller12 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectWidget1/viewer.controller.ts';
            import * as _controllerExport12 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectWidget1/model.ts';
            var controllerExport12 = _controllerExport12;
            

            
import wrapController13 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller13 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/tagsPageWidget/viewer.controller.ts';
            import * as _controllerExport13 from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/tagsPageWidget/model.ts';
            var controllerExport13 = _controllerExport13;
            

  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://bfb679c754744c58a7374ee6e25cfc13@sentry.wixpress.com/2954',
      id: 'bfb679c754744c58a7374ee6e25cfc13',
      projectName: 'portfolio-bob-xj',
      teamName: 'photography-portfolio',
      errorMonitor: true,
    };

  var experimentsConfig = {"scopes":["portfolio"],"centralized":true};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hu","id","it","ja","ko","lt","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"Project_Elements_Panel_Category_Details":"Basic Info","Project_Design_Panel_Header_Background":"Header Background","Project_Elements_Panel_Navigation":"Navigation Buttons","Settings_GFPP_Submenu_DisabledText":"Create a dropdown submenu with your project pages. If you have multiple collections, the submenu will show your collections.","Project_Elements_Panel_Description":"Description","Featured_Collection_Design_Panel_Background":"Background","Collection_Elements_Panel_Category_Info":"Collection Info","Collection_Elements_Panel_Title":"Title","Widget_Name_Project_Header_Widget":"Project Header","Project_Elements_Panel_Category_Info":"Project Info","Widget_Name_Portfolio_Page_Widget":"Portfolio Page","Portfolio_Elements_Panel_Description":"Description","Collection_Page_Widget_Design_Panel_Preset_Title":"Collection Presets","Widget_Name_Collections_List_Widget":"Collection Gallery","Project_Design_Panel_Description":"Description","Collection_Elements_Panel_Navigation":"Back Button","Project_Page_Widget_Design_Panel_Preset_Title":"Project Presets","Project_Elements_Panel_Details_Text":"Text","Settings_GFPP_Submenu_ToggleLabel":"Add a Portfolio submenu","Widget_Name_Collections_Page_Widget":"Collection Page","Project_Elements_Panel_Category_Navigation":"Project Navigation","Collection_Page_Title":"Collection pages","Project_Elements_Panel_Details_Label":"Label","Portfolio_Elements_Panel_Category_Media":"Portfolio Media","Portfolio_Elements_Panel_Category_Info":"Portfolio Info","Project_Page_Connected_Component_Description":"Edit Text","Collection_Widget_Connected_Component_Collection_Gallery":"Manage Projects","Collection_Widget_Connected_Component_Title":"Edit Text","Project_Elements_Panel_Details":"Basic Info","Portfolio_Page_Title":"Portfolio","Project_Elements_Panel_Hero_Image":"Cover","Project_Page_Connected_Component_Gallery":"Manage Media","Page_Builder_Portfolio_Page_Tooltip":"This is portfolio page tooltip","Portfolio_Page_Widget_Gfpp_Main_Action_2":"Manage Collections","Widget_Name_Tags_Page_Widget":"Tags Page","Project_Page_Connected_Component_Details_Label":"Edit Text","Settings_GFPP_Submenu_Enabled_MultipleCollections":"Create a dropdown submenu with your project pages. If you have multiple collections, the submenu will show your collections.","Widget_Name_Project_Details_Widget":"Project Info","Widget_Name_Navigation_Button_Widget":"Navigation Button","Management_Actions_Manage_Projects":"Manage Projects","Widget_Name_Project_Widget":"Project","Portfolio_Design_Panel_Title":"Title","Native_Gallery_Gfpp_Main_Action_1_Layout":"Layout","Collection_Widget_Connected_Component_Collections_Gallery":"Manage Collections","Featured_Collection_Widget_Gfpp_Main_Action_1":"Manage Projects","Collection_Elements_Panel_Category_Navigation":"Collection Navigation","Project_Design_Panel_Navigation_Buttons":"Navigation Buttons","Collection_Design_Panel_Page_Background":"Background","Collection_Design_Panel_Projects_Gallery":"Projects Gallery","Page_Builder_Collection_Page_Tooltip":"This is collection page tooltip","Tag_Page_Title":"Tag","Project_Elements_Panel_Back_Navigation":"Previous Button","Page_Builder_Settings_Tab_Action_Delete_App":"Delete","Collection_Design_Panel_Description":"Description","Widget_Name_Navigation_Widget":"Navigation","Collection_Page_Back_To_Portfolio_Button":"Back to Portfolio","Project_Page_Connected_Component_Details_Text":"Edit Text","Project_Page_Widget_Design_Panel_Title":"Project Page Design","Page_Builder_Page_Action_Set_As_Home":"Set as Homepage","Project_Page_Connected_Component_Title":"Edit Text","Featured_Collection_Design_Panel_Projects_Gallery":"Projects Gallery","Page_Builder_Settings_Tab_Page_Layout":"Layout","Featured_Collection_Widget_Design_Panel_Title":"Featured Collection Design","Pages_Tab_Builder_App_Name":"Portfolio Pages","Project_Page_Connected_Component_Cover":"Edit Cover","Project_Design_Panel_Details_Label":"Basic Info Label","Collection_Elements_Panel_Description":"Description","Portfolio_Design_Panel_Description":"Description","Featured_Collection_Design_Panel_Title":"Title","Portfolio_Elements_Panel_Gallery":"Gallery of Projects","Management_Actions_Add_New_Project":"Add New Project","Project_Elements_Panel_Next_Navigation":"Next Button","Project_Design_Panel_Details_Text":"Basic Info Text","Collection_Elements_Panel_Category_Media":"Collection Media","Portfolio_Page_Widget_Design_Panel_Title":"Portfolio Design","Project_Design_Panel_Hero_Image":"Cover","Project_Page_Title":"Project pages","Collection_Page_Widget_Gfpp_Main_Action_1":"Manage Collections","Featured_Collection_Widget_Gfpp_Main_Action_2":"Choose Collections","Project_Page_Widget_Gfpp_Main_Action_2":"Change Design","Management_Actions_Manage_Collection":"Manage Collections","Project_Design_Panel_Gallery":"Gallery","Portfolio_Design_Panel_Projects_Gallery":"Projects Gallery","Widget_Name_Collection_MSB_Widget":"Collection MSB","Management_Actions_Manage_Pages":"Manage Pages","Project_Elements_Panel_Category_Gallery":"Project Media","Portfolio_Elements_Panel_Title":"Title","Collection_Widget_Connected_Component_Description":"Edit Text","Collection_Elements_Panel_Gallery":"Gallery of Projects","Page_Builder_Settings_Tab_Page_Info":"Page Info","Featured_Collection_Design_Panel_Description":"Description","Widget_Name_Collections_Widget":"Collection","Project_Page_Next_Project_Button":"Next Project","Widget_Name_Project_Page_Widget":"Project Page","Page_Builder_Page_Action_Rename":"Rename","Text_Component_Gfpp_Main_Action_1":"Design Text","Project_Page_Previous_Project_Button":"Previous Project","Widget_Name_Featured_Collection_Widget":"Featured Collections Gallery","Project_Design_Panel_Page_Background":"Page Background","Page_Builder_Settings_Tab_Page_Permissions":"Permissions","Project_Elements_Panel_Title":"Title","Portfolio_Page_Widget_Gfpp_Main_Action_1":"Manage Projects","Settings_GFPP_Submenu_Enabled_SingleCollection":"Create a dropdown submenu with your project pages. If you have multiple collections, the submenu will show your collections.","Widget_Name_Collections_Gallery_Widget":"Collection Gallery","Project_Design_Panel_Title":"Title","Management_Actions_Add_Widget_To_Page":"Add Featured Collections Gallery","Collection_Page_Widget_Gfpp_Main_Action_2":"Change Design","Portfolio_Design_Panel_Page_Background":"Background","Page_Builder_Settings_Tab_Page_Seo":"Seo","Collection_Design_Panel_Title":"Title","Project_Page_Widget_Gfpp_Main_Action_1":"Manage Projects","Collection_Design_Panel_Back_Button":"Back Button","Page_Builder_Project_Page_Tooltip":"This is project page tooltip","Project_Elements_Panel_Gallery":"Gallery","Project_Header_Widget_Design_Panel_Title":"Project Header Design","Collection_Page_Widget_Design_Panel_Title":"Collection Page Design"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "portfolio-bob",
    biConfig: null,
    appName: "Wix Portfolio",
    appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionMSBWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "collectionMSBWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-yufgs" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionPageWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "collectionPageWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-voiu8" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "collectionWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-os5sm" }, { method: controller3,
          wrap: wrapController3,
          exports: controllerExport3,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionsGalleryWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "collectionsGalleryWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-itb6f" }, { method: controller4,
          wrap: wrapController4,
          exports: controllerExport4,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/collectionsListWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "collectionsListWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-waybk" }, { method: controller5,
          wrap: wrapController5,
          exports: controllerExport5,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/featuredCollectionWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "featuredCollectionWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-jqcf0" }, { method: controller6,
          wrap: wrapController6,
          exports: controllerExport6,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/navigationButtonWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "navigationButtonWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-aob4e" }, { method: controller7,
          wrap: wrapController7,
          exports: controllerExport7,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/navigationWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "navigationWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-zmzxw" }, { method: controller8,
          wrap: wrapController8,
          exports: controllerExport8,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/portfolioPageWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "portfolioPageWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-n0thf" }, { method: controller9,
          wrap: wrapController9,
          exports: controllerExport9,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectDetailsWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "projectDetailsWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-lfhru" }, { method: controller10,
          wrap: wrapController10,
          exports: controllerExport10,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectHeaderWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "projectHeaderWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-vvhj5" }, { method: controller11,
          wrap: wrapController11,
          exports: controllerExport11,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectPageWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "projectPageWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-yaafe" }, { method: controller12,
          wrap: wrapController12,
          exports: controllerExport12,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/projectWidget1/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "projectWidget1",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-ojo5l" }, { method: controller13,
          wrap: wrapController13,
          exports: controllerExport13,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"scopes":["portfolio"],"centralized":true},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/993401d6a0121e58/packages/portfolio-bob/src/components/tagsPageWidget/viewer.controller.ts",
          appName: "Wix Portfolio",
          appDefinitionId: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130",
          projectName: "portfolio-bob",
          componentName: "tagsPageWidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "d90652a2-f5a1-4c7c-84c4-d4cdcc41f130-vp33g" }],
    false);

    export const createControllers = _createControllers
